import { ColumnsType } from 'antd/lib/table';
import Table from 'components/Table';
import { MobileTableType } from 'components/Table/types';
import { formatDateTimeForDisplay } from 'constants/days';
import deviceSizes from 'constants/deviceSizes';
import moment from 'moment';
import React from 'react';
import { AppointmentNotaryTypeDisplay } from 'types/appointments';

import { IInvoicePaymentProps } from './types';

const InvoiceDetailTable: React.FC<IInvoicePaymentProps> = ({ invoice }) => {
  const invoiceTableColumn: ColumnsType<any> = [
    { dataIndex: 'date', title: 'Date' },
    { dataIndex: 'type', title: 'Type' },
    {
      dataIndex: 'signatories',
      title: 'Signatories',
      width: '50%',
      render: (signatories: any) => <span className='gx-font-weight-medium'>{signatories}</span>,
    },
    {
      dataIndex: 'amount',
      title: 'Amount',
      render: (amount: any) => <span style={{ color: '#038fde' }}>${amount}</span>,
      width: '15%',
    },
  ];

  const dataSource = invoice?.invoiceDetails?.map((invoiceDetail) => {
    const invoiceFee = invoiceDetail.fee;

    const transactionOfAppointment = invoiceDetail?.appointment?.transaction;

    const signatories = invoiceDetail?.appointment.signatoryIds?.reduce((acc, sigId) => {
      const signatory = transactionOfAppointment?.signatories.find((sigIdInTrans) => sigId === sigIdInTrans.id);
      if (signatory) {
        return `${acc}${acc ? ', ' : ''}${signatory.firstName} ${signatory.lastName}`;
      }
      return acc;
    }, '');
    return {
      key: invoiceDetail.id,
      date: moment(invoiceDetail?.appointment.date).format(formatDateTimeForDisplay('|')),
      type: AppointmentNotaryTypeDisplay[invoiceDetail?.appointment.type],
      signatories,
      amount: invoiceFee,
    };
  });
  return (
    <div className='p-4 sm:p-0'>
      <Table
        dataSource={dataSource}
        columns={invoiceTableColumn}
        pagination={false}
        widthThreshold={deviceSizes.numbers.sm}
        mobileDesignType={MobileTableType.RESPONSIVE_TABLE}
        responsiveFullBordered
      />
    </div>
  );
};

export default React.memo(InvoiceDetailTable);
